const ELEMENT_TYPE_LABELS = {
  headline: "headline",
  text: "text",
  image: "image",
  video: "video",
  list: "list",
  button: "button",
  form: "form",
  quiz: "quiz",
  survey: "survey",
  products: "product feed",
  product_hero: "product hero",
  html: "custom HTML",
  divider: "divider",
  icon: "icon",
  tabs: "tabs",
  carousel: "carousel",
  ticker: "ticker",
  conditional_row: "conditional row",
  timer: "timer",
  progress: "progress bar",
  collapse: "collapse",
  row: "row",
  logo: "logo",
  reviews: "reviews",
  embed: "embed",
  scheduler: "scheduler",
};

const ELEMENT_TYPE_ARTICLES = {
  image: "an",
  icon: "an",
  html: "a",
  embed: "an",
};

export const resolveElementCreationLabel = (elementType) => {
  if (!elementType || elementType === "all") return null;

  const label = ELEMENT_TYPE_LABELS[elementType];
  if (!label) return null;

  return {
    elementType,
    label,
    article: ELEMENT_TYPE_ARTICLES[elementType] || "a",
  };
};

export default resolveElementCreationLabel;
